import NewUserAINavigatorBoxes from "./NewUserAINavigatorBoxes";

export default NewUserAINavigatorBoxes;